import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./PaymentTermsForm";
import {cancelSetPaymentTerms} from "../../actions/AccountApiActions";
import {Map} from "immutable";
import {validateGreaterThan} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validateGreaterThan(errors, values, "days", 0);
  return errors.toJS();
}

class SetPaymentTermsFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.changePaymentMethodToPaymentTerms(values.set("accountId", this.props.accountId).toJS())
      .then((response) => {
        if (response.data.changePaymentMethodToPaymentTerms.errors.length <= 0) {
          this.props.cancelSetPaymentTerms();
        } else {
          let errors = createValidationErrors(response.data.changePaymentMethodToPaymentTerms.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelSetPaymentTerms();
  }

  render() {
    // let {data} = this.props;
    // if (data.loading) return <Loading />
    // if (data.error) return <p>{data.error}</p> 
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CHANGE_PAYMENT_METHOD = gql`
  mutation changePaymentMethodToPaymentTerms($data: BillingPaymentTermsInput!) {
    changePaymentMethodToPaymentTerms(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(CHANGE_PAYMENT_METHOD, {
    props: ({ mutate }) => ({
      changePaymentMethodToPaymentTerms: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);


export default connect(null, {cancelSetPaymentTerms})(withQueries(SetPaymentTermsFormContainer));